import React from 'react'
import { Icon as IconType } from 'react-feather'

import s from './icon.module.scss'
import './icon.module.scss'

type IconProps = {
    size?: number
    src: IconType
    attrs?: {
        width: number
        [key: string]: string | number
    }
}

/**
 * The Icon component allows us to wrap each icon with some default styling.
 */
const Icon = (props: IconProps): JSX.Element => {
    const {
        attrs: { width, ...restAttrs } = { width: 18 },
        size = 18,
        src: IconComponent
    } = props

    // Permit both prop styles:
    // <Icon src={Foo} attrs={{ width: 18 }} />
    // <Icon src={Foo} size={18} />
    return (
        <span className={s['icon-root']}>
            <IconComponent size={size || width} {...restAttrs} />
        </span>
    )
}

export default Icon
